{
  "attachAria": "Joindre un fichier",
  "emptyHint": "Décris ton problème — l'assistance te répondra ici",
  "emptyTitle": "Pas encore de messages",
  "fileOpenAria": "Ouvrir la pièce jointe",
  "logAria": "Conversation de la demande",
  "newMessages": "Nouveaux messages",
  "placeholder": "Écris un message…",
  "placeholderDisabled": "Les messages sont temporairement indisponibles",
  "previewAria": "Voir la pièce jointe",
  "previewCloseAria": "Fermer l'aperçu",
  "removeAttachmentAria": "Supprimer le fichier",
  "retry": "Réessayer",
  "screenshotAria": "Faire une capture d'écran",
  "seen": "Vu",
  "sendAria": "Envoyer le message",
  "sendFailed": "Le message n'a pas pu être envoyé",
  "sending": "Envoi…",
  "student": "Élève",
  "supportName": "Assistance Skyeng",
  "today": "Aujourd’hui",
  "yesterday": "Hier",
  "you": "Toi"
}
